<div class="container">
  <div class="address-correction-header">
    <pdq-tabs-group variant="toggle" (onChange)="onTabChange($event)">
      <pdq-tab label="Configurations" value="configurations" [active]="true"> </pdq-tab>
      <pdq-tab label="Flagged Orders" value="flagged-orders" [active]="false"> </pdq-tab>
    </pdq-tabs-group>
    <ng-container *ngTemplateOutlet="flaggedOrders?.toolbarTemplate"></ng-container>
  </div>

  @if (activeTab === 'configurations') {
    <address-validation-configurations></address-validation-configurations>
  }
  @if (activeTab === 'flagged-orders') {
    <address-validation-flagged-orders #flaggedOrders></address-validation-flagged-orders>
  }
</div>
